import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { visibleModules } from "@/lib/content";
import { t } from "@/lib/i18n";
import Reveal from "@/components/Reveal";
import { Pending, StatusLabel, StockBadge } from "@/components/Pending";
import { path } from "@/lib/routes";

function AreaCard({ m, i, isPreview }) {
  const showImg = m.image && (isPreview || m.image_stock === false);
  return (
    <Reveal delay={i * 80} className={i === 0 ? "sm:col-span-2 lg:col-span-1 lg:row-span-2" : ""}>
      <Link to={`${path("kesfet")}#${m.id}`} className="group block h-full rounded-2xl overflow-hidden bg-white border border-line transition-shadow duration-300 hover:shadow-[0_18px_50px_-24px_rgba(30,58,43,0.45)]" data-testid={`home-area-card-${m.id}`}>
        {showImg && (
          <div className={`relative overflow-hidden ${i === 0 ? "aspect-[4/3] lg:aspect-[3/4]" : "aspect-[16/10]"}`}>
            <img src={m.image} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
            {isPreview && m.image_stock !== false && <StockBadge className="absolute top-3 left-3" />}
          </div>
        )}
        <div className="p-6 space-y-3">
          <div className="flex items-start justify-between gap-4">
            <h3 className="text-2xl font-semibold leading-tight text-wood">{m.title || t("preview.pending")}</h3>
            <ArrowUpRight className="h-5 w-5 shrink-0 text-honey-ink transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
          </div>
          {isPreview && <div className="flex flex-wrap gap-2"><StatusLabel status={m.status} />{!m.body && <Pending />}</div>}
        </div>
      </Link>
    </Reveal>
  );
}

export default function Areas({ content, isPreview }) {
  const modules = visibleModules(content, isPreview);
  if (!modules.length) return null;
  return (
    <section className="bg-cream-2 py-20 sm:py-28" data-testid="home-areas">
      <div className="safe-x max-w-7xl mx-auto">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <p className="eyebrow mb-4">{t("home.areasEyebrow")}</p>
            <h2 className="text-4xl sm:text-5xl font-semibold text-forest max-w-xl leading-[1.08]">{t("home.areasTitle")}</h2>
          </div>
          <Link to={path("kesfet")} className="inline-flex items-center gap-2 min-h-[44px] font-semibold text-forest underline-offset-4 hover:underline" data-testid="home-areas-all-link">
            {t("home.areasLink")} <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </Reveal>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {modules.map((m, i) => <AreaCard key={m.id} m={m} i={i} isPreview={isPreview} />)}
        </div>
      </div>
    </section>
  );
}
